module.exports = __webpack_public_path__ + "media/warning.c5c8a1be.mp3";